<template>
  <v-dialog
      ref="dialog"
      v-model="modal"
      :return-value.sync="value"
      persistent
      width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
          :value="dateString"
          :label="label"
          prepend-inner-icon="mdi-calendar"
          readonly
          v-bind="$attrs"
          v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker v-model="date" scrollable color="primary" v-bind="$attrs" :locale="locale">
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="modal = false">
        {{ i18n.t("_Cancel") }}
      </v-btn>
      <v-btn text color="primary" @click="$refs.dialog.save(value)">
        {{ i18n.t("_Confirm") }}
      </v-btn>
    </v-date-picker>
  </v-dialog>
</template>
<script>
import i18n from "../helper/i18n"
import moment from "moment"

export default {
  props: {
    value: {
      required: true,
    },
    label: {
      type: String,
    },
  },
  data() {
    return {
      modal: false,
      date: undefined,
      i18n: i18n
    };
  },
  mounted() {
    this.date = this.value;
  },
  computed: {
    locale() {
      let locale = localStorage.getItem("locale");
      if (locale === null) locale = "en"

      return locale
    },
    dateString() {
      return moment(this.date).locale(this.locale).format("ll")
    }
  },
  watch: {
    date: function () {
      if (this.date === undefined) return;

      this.$emit("input", this.date);
    },
  },
};
</script>
